/**
 * playerStatsView — personal stats formatting + markup (M3 extraction).
 *
 * The math and stat-grid markup lived inline in main.ts's ACCOUNT "LOAD
 * STATS" handler; it MOVED here so the classic account tab and the new
 * RANKINGS screen share one implementation. Markup classes are the existing
 * `.acct-stat-*` ones — their styles are top-level in style.css, so the grid
 * looks right in both homes.
 */

import type { PlayerStats } from "../auth/AuthClient.js";

export interface PlayerStatsSummary {
  kd: string;
  hours: string;
  winRate: number;
}

export function summarizePlayerStats(stats: PlayerStats): PlayerStatsSummary {
  const kd = stats.deaths > 0 ? (stats.kills / stats.deaths).toFixed(2) : stats.kills.toFixed(2);
  const hours = (stats.time_played_ms / 3_600_000).toFixed(1);
  const winRate = stats.matches > 0 ? Math.round((stats.wins / stats.matches) * 100) : 0;
  return { kd, hours, winRate };
}

/** Stat grid + per-vehicle rows — byte-identical to the old main.ts markup. */
export function buildPlayerStatsHtml(stats: PlayerStats): string {
  const { kd, hours, winRate } = summarizePlayerStats(stats);
  const vRows = stats.vehicleStats
    .map(
      (v) => `<div class="acct-vrow"><span>${v.vehicle_id}</span><span>${v.kills}K / ${v.deaths}D</span></div>`,
    )
    .join("");
  return `
        <div class="acct-stat-grid">
          <div><span class="acct-stat-val">${stats.kills}</span><span class="acct-stat-lbl">KILLS</span></div>
          <div><span class="acct-stat-val">${stats.deaths}</span><span class="acct-stat-lbl">DEATHS</span></div>
          <div><span class="acct-stat-val">${kd}</span><span class="acct-stat-lbl">K/D</span></div>
          <div><span class="acct-stat-val">${stats.matches}</span><span class="acct-stat-lbl">MATCHES</span></div>
          <div><span class="acct-stat-val">${stats.wins}</span><span class="acct-stat-lbl">WINS</span></div>
          <div><span class="acct-stat-val">${winRate}%</span><span class="acct-stat-lbl">WIN RATE</span></div>
          <div><span class="acct-stat-val">${hours}h</span><span class="acct-stat-lbl">TIME</span></div>
        </div>
        ${vRows ? `<div class="acct-vehicles">${vRows}</div>` : ""}
      `;
}
